export default __webpack_public_path__ + "static/media/patient-room-2.37759a64.jpg";